import { asyncActionCreators } from "../../lib/util/ReduxUtils";

import * as Api from "../../Api";
import * as Flags from "../../lib/Flags";
import * as StorageUtils from "../../lib/util/StorageUtils";
import * as ArrayUtils from "../../lib/util/ArrayUtils";
import * as FleetSelectors from "./Fleet.selector";
import * as UserSelectors from "../User/User.selector";
import * as ProgramActions from "../../store/Program/Program.action";
import * as GlobalActions from "../../store/Global/Global.action";
import { FLEETS_KEY } from "../../StorageKeys";

import { Fleet } from "../../lib/types/Fleet";

/**
 * Get the fleet scoped to
 */
export const getScopeFleet = asyncActionCreators<
	{ fleetId: string; group?: string | null; noCache?: boolean },
	Fleet
>("[FLEET] GET_SCOPE_FLEET", async (action, dispatch, getState) => {
	const { fleetId, noCache, group } = action.payload;
	const call = Api.fetchFleet
		.submit({ params: { fleetId }, query: { group, includeParams: true } })
		.then((result) => result.data);
	const state = getState();
	const all: { value?: Fleet[] } = FleetSelectors.getAllFleets(state);
	const cached: Fleet | undefined =
		!noCache && all.value
			? all.value.find((fleet) => fleet.id === fleetId)
			: undefined;
	if (cached) {
		// save new result
		call
			.then((fleetData) => {
				// update cached version
				const cached = StorageUtils.get(FLEETS_KEY);
				StorageUtils.set(
					FLEETS_KEY,
					cached?.map((fleet: Fleet) => {
						if (fleet.id === fleetId) {
							return {
								...fleet,
								...fleetData,
							};
						}
						return fleet;
					}),
				);

				if (fleetData.programId) {
					dispatch(
						ProgramActions.getProgramData({
							programId: fleetData.programId,
						}),
					);
				}

				dispatch(getScopeFleet.resolved(fleetData));
				return fleetData;
			})
			.catch((e) => console.error("Error refreshing fleet", e));
		return cached;
	}

	let response;

	try {
		response = await call;
	} catch (error) {
		if (error.response?.status === 401) {
			const user = UserSelectors.selectLoggedInUser(state);

			if (user?.group && user.group !== group) {
				// Kick user back to their group
				dispatch(
					GlobalActions.setScope({
						fleetId,
						group: user.group,
						rootGroupId: user.rootGroup,
					}),
				);
			}
		}

		throw error;
	}

	return response;
});

/**
 * Retrieve all fleets
 */
export const getAllFleets = asyncActionCreators<void, Fleet[]>(
	"[FLEET] GET_ALL_FLEETS",
	async () => {
		const res = await Api.fetchFleets.submit({
			query: {
				showArchived: Flags.SHOW_ARCHIVED_FLEETS.is(),
			},
		});
		const allFleets = [
			{
				id: Flags.DEMO_FLEET_ID,
				name: Flags.DEMO_FLEET_NAME,
			},
			...res.data,
		];

		const fleets = ArrayUtils.uniqueArray(allFleets, "id");

		if (!Flags.DEMO_MODE.is()) {
			StorageUtils.set(FLEETS_KEY, fleets);
		}
		return fleets;
	},
);
